import { Chip, IconButton, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { CheckCircle, Refresh, Visibility } from '@mui/icons-material';
import { GeneralTableBox, HeadTableCell, LoadingSkeleton, NoDataSkeleton, RowTableCell } from '../../../common/components';
import { COUPON_DUE_TYPE, MODULE_LABELS } from '../constants/notificationsConstants';
import {
  formatDateTime,
  getNotificationMessageText,
  getNotificationPriorityText,
  getNotificationRuleText,
  getRecipientLabels,
  statusChip,
  truncateText,
} from '../utils/notificationUtils';

export const InboxTable = ({ events, loading, onView, onAction, actionLoading }) => (
  <Paper elevation={0}>
    <GeneralTableBox>
      <Table>
        <TableHead>
          <TableRow>
            <HeadTableCell>Prioridad</HeadTableCell>
            <HeadTableCell>Regla</HeadTableCell>
            <HeadTableCell>Mensaje</HeadTableCell>
            <HeadTableCell>Contrato</HeadTableCell>
            <HeadTableCell>Destinatario</HeadTableCell>
            <HeadTableCell>Estado</HeadTableCell>
            <HeadTableCell>Generada</HeadTableCell>
            <HeadTableCell sx={{ width: 96, minWidth: 96 }}>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={8}>
                <LoadingSkeleton />
              </TableCell>
            </TableRow>
          )}
          {!loading && events.length === 0 && (
            <NoDataSkeleton colSpan={8} message="No hay notificaciones con los filtros actuales." />
          )}
          {events.map((event) => {
            const canRetryDelivery = event.notification_type === COUPON_DUE_TYPE;
            const ruleText = getNotificationRuleText(event);
            const messageText = getNotificationMessageText(event);
            const recipientLabels = getRecipientLabels(event);
            const firstRecipient = recipientLabels[0] || '-';
            const extraRecipients = Math.max(recipientLabels.length - 1, 0);

            return (
              <TableRow key={event.uuid} hover>
              <RowTableCell>
                <Stack spacing={0.5}>
                  <Chip
                    label={getNotificationPriorityText(event)}
                    color={event.is_urgent ? 'error' : 'default'}
                    size="small"
                  />
                  <Typography variant="caption" color="text.secondary">
                    {MODULE_LABELS[event.target_app_module] || event.target_app_module}
                  </Typography>
                </Stack>
              </RowTableCell>
              <RowTableCell sx={{ maxWidth: 160 }}>
                <Tooltip title={ruleText}>
                  <Typography variant="body2" noWrap>
                    {truncateText(ruleText, 30)}
                  </Typography>
                </Tooltip>
              </RowTableCell>
              <RowTableCell sx={{ maxWidth: 260 }}>
                <Tooltip title={messageText}>
                  <Typography variant="body2" color="text.secondary" noWrap>
                    {truncateText(messageText, 50)}
                  </Typography>
                </Tooltip>
              </RowTableCell>
              <RowTableCell>{event.contract_number || '-'}</RowTableCell>
              <RowTableCell sx={{ maxWidth: 190 }}>
                <Tooltip title={recipientLabels.join(', ') || 'Sin destinatario'}>
                  <Stack>
                    <Typography variant="body2" noWrap>
                      {firstRecipient}
                    </Typography>
                    {extraRecipients > 0 && (
                      <Typography variant="caption" color="text.secondary">
                        +{extraRecipients} más
                      </Typography>
                    )}
                  </Stack>
                </Tooltip>
              </RowTableCell>
              <RowTableCell>{statusChip(event.status)}</RowTableCell>
              <RowTableCell>{formatDateTime(event.generated_at || event.created_at)}</RowTableCell>
              <RowTableCell sx={{ width: 96, minWidth: 96, px: 1, verticalAlign: 'middle' }}>
                <Stack
                  direction="row"
                  spacing={0.5}
                  justifyContent="center"
                  alignItems="center"
                  flexWrap="nowrap"
                >
                  <Tooltip title="Ver detalle">
                    <IconButton size="small" onClick={() => onView(event.uuid)}>
                      <Visibility fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Marcar leída">
                    <span style={{ display: 'inline-flex' }}>
                      <IconButton
                        size="small"
                        onClick={() => onAction(event.uuid, 'read')}
                        disabled={actionLoading || event.status !== 'new'}
                      >
                        <CheckCircle fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                  {canRetryDelivery && (
                    <Tooltip title="Reintentar envío">
                      <IconButton
                        size="small"
                        onClick={() => onAction(event.uuid, 'retry')}
                        disabled={actionLoading}
                      >
                        <Refresh fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Stack>
              </RowTableCell>
            </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </GeneralTableBox>
  </Paper>
);
